import React from "react";

interface InputProps {
	placeholder?: string;
	className?: string;
	variant?: "primary" | "secondary";
	isDisabled?: boolean;
	label?: string;
	value: string;
	onChange: (value: string) => void;
	error?: string;
	type?: string;
	autoFocus?: boolean;
	required?: boolean;
}

const CustomTextInput: React.FC<InputProps> = ({
	onChange,
	placeholder,
	className = "",
	value,
	error,
	type,
	isDisabled = false,
	autoFocus = undefined,
	required,
}) => {
	const baseStyles =
		"px-4 py-3 rounded-md font-semibold transition-all duration-200 flex items-center justify-center gap-2 outline-none";

	return (
		<div className="flex flex-col gap-2">
			<input
				className={`${baseStyles} ${className}`}
				placeholder={placeholder}
				value={value}
				type={type}
				onChange={(e) => onChange(e.target.value)}
				disabled={isDisabled}
				autoFocus={autoFocus}
				required={required}
			/>
			{error && <span className="text-red-500">{error}</span>}
		</div>
	);
};

export default CustomTextInput;
